import React from "react";
import PropTypes from "prop-types";
import { polyfill } from "interweave-ssr";

polyfill();
export default function Pagination({ pages, setApiUrl, apiUrl, setPaginatedPosts }) {
  if(pages.length > 3){
  return (
    <div className="py-10 ">
      <ul className="flex justify-center items-center w-full !list-none gap-x-3">
        {pages.map((page, index) =>
          page.label == "&laquo; Anterior" ||
          page.label == "Siguiente &raquo;" ? (
            null
          ) : (
            <li
              key={index}
              onClick={()=>{setApiUrl(page.url); setPaginatedPosts(null)}}
              className={`
              border border-gray-200 w-10 h-10 select-none flex rounded-full font-semibold cursor-pointer items-center justify-center
              ${
                page.url === apiUrl || (page.label == 1 && apiUrl == null )
                  ? "bg-blue-light text-white pointer-events-none"
                  : "pageItem"
              }`}
            >
              <a href="#" className={"pageLink"}>{page.label}</a>
            </li>
          )
        )}
      </ul>
    </div>
  );
}
}

Pagination.propTypes = {
  items: PropTypes.any,
  setPaginatedPosts: PropTypes.any,
  pageSize: PropTypes.any,
  pages: PropTypes.any,
  apiUrl: PropTypes.any,
  onPageChange: PropTypes.any,
  setApiUrl: PropTypes.any,
};
